import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const BackButton = ({ to }) => (
    <Link to={to} className="back-button" aria-label="Go back">
        <FontAwesomeIcon icon={faArrowLeft} />
    </Link>
);

BackButton.propTypes = {
    to: PropTypes.string.isRequired,
};

export default BackButton;
